import { computed } from 'vue';
import { useSessionStore } from '@/stores/session.store';

export const usePatientPermissions = () => {
  const sessionStore = useSessionStore();

  const canReadPatient = computed(() =>
    sessionStore.permissions.includes('patient:read')
  );

  const canCreatePatient = computed(() =>
    sessionStore.permissions.includes('patient:create')
  );

  return {
    canReadPatient,
    canCreatePatient
  };
};
